import React, { useEffect, useState } from "react";

const DeliveryForm = ({ addressdetails, selectedcheckoutAddressDetails }) => {
  const [addressLine1, setAddress1] = useState("");
  const [addressLine2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [state, setState] = useState("");

  useEffect(() => {
    setAddress1(addressdetails?.addressLine1 || "");
    setAddress2(addressdetails?.addressLine2 || "");
    setCity(addressdetails?.city || "");
    setPostalCode(addressdetails?.postalCode || "");
    setState(addressdetails?.state || "");
  }, [addressdetails]);

  const updateParent = (
    newAddress1 = addressLine1,
    newAddress2 = addressLine2,
    newCity = city,
    newPostalCode = postalCode,
    newState = state
  ) => {
    selectedcheckoutAddressDetails({
      addressLine1: newAddress1,
      addressLine2: newAddress2,
      city: newCity,
      postalCode: newPostalCode,
      state: newState,
    });
  };

  const handleChangeAddress1 = (e) => {
    const value = e.target.value;
    setAddress1(value);
    updateParent(value);
  };

  const handleChangeAddress2 = (e) => {
    const value = e.target.value;
    setAddress2(value);
    updateParent(addressLine1, value);
  };

  const handleChangeCity = (e) => {
    const value = e.target.value;
    setCity(value);
    updateParent(addressLine1, addressLine2, value);
  };

  const handleChangePostalCode = (e) => {
    const value = e.target.value;
    setPostalCode(value);
    updateParent(addressLine1, addressLine2, city, value);
  };

  const handleChangeState = (e) => {
    const value = e.target.value;
    setState(value);
    updateParent(addressLine1, addressLine2, city, postalCode, value);
  };

  return (
    <div className="deliveryformcontainer t6">
      <div className="delivery-input-container">
        <input
          type="text"
          placeholder="Address Line 1"
          value={addressLine1}
          onChange={handleChangeAddress1}
        />
      </div>

      <div className="delivery-input-container">
        <input
          type="text"
          placeholder="Address Line 2"
          value={addressLine2}
          onChange={handleChangeAddress2}
        />
      </div>

      <div className="delivery-input-container">
        <input
          type="text"
          placeholder="Town / City"
          value={city}
          onChange={handleChangeCity}
        />
      </div>

      <div className="delivery-input-container">
        <input
          type="number"
          placeholder="Pin Code"
          value={postalCode}
          onChange={handleChangePostalCode}
        />
      </div>

      <div className="delivery-input-container">
        <input
          type="text"
          placeholder="State"
          value={state}
          onChange={handleChangeState}
        />
      </div>
    </div>
  );
};

export default DeliveryForm;